// 解决激活不匹配，判断是否在有onMounted执行
// 示例：const { isMounted } = useIsMounted()
export const useIsMounted = () => {
  const isMounted = ref(false)
  onMounted(() => {
    isMounted.value = true
  })
  return {
    isMounted
  }
}
